// Utilitários de máscara para inputs (pt-BR). Funções puras, sem dependências.

/** Remove tudo que não é dígito. */
export const onlyDigits = (s: string): string => s.replace(/\D/g, '');

/**
 * Aplica progressivamente a máscara de CNPJ (00.000.000/0000-00) enquanto o
 * usuário digita. Aceita entrada parcial e ignora dígitos além de 14.
 */
export function maskCNPJ(raw: string): string {
  const d = onlyDigits(raw).slice(0, 14);
  let out = d.slice(0, 2);
  if (d.length > 2) out += '.' + d.slice(2, 5);
  if (d.length > 5) out += '.' + d.slice(5, 8);
  if (d.length > 8) out += '/' + d.slice(8, 12);
  if (d.length > 12) out += '-' + d.slice(12, 14);
  return out;
}

const brlFormatter = new Intl.NumberFormat('pt-BR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

/** Formata um inteiro de centavos como "1.433.246,10" (sem símbolo). */
export const centsToBRL = (cents: number): string =>
  brlFormatter.format((Number.isFinite(cents) ? cents : 0) / 100);

/** Converte um número em reais para inteiro de centavos. */
export const numberToCents = (n: number): number =>
  Number.isFinite(n) ? Math.round(n * 100) : 0;

/** Dígitos digitados (estilo caixa) → número em reais. Ex.: "14332461" → 143324.61 */
export function parseMoneyToNumber(display: string): number {
  const d = onlyDigits(display);
  if (!d) return 0;
  return parseInt(d, 10) / 100;
}
